import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-t border-white/5 bg-void-950 py-24 md:py-32" data-id="element-55" data-mp="1gk58qtu87emz">
      <div className="mx-auto max-w-3xl px-6" data-id="element-56" data-mp="24a93sctcm62d">
        <Reveal data-id="element-57" data-mp="24bk6saeyz9sf">
          <SectionLabel data-id="element-58" data-mp="28ajkajeroevh">Resolvemos tus dudas</SectionLabel>
          <h2 className="font-display text-3xl font-light leading-tight text-bone-50 sm:text-4xl md:text-5xl" data-id="element-59" data-mp="289zzmuxqfcdr">
            Preguntas frecuentes
          </h2>
        </Reveal>

        <div className="mt-12 divide-y divide-white/5 border-y border-white/5" data-id="element-60" data-mp="1zh6i0qutc0wq">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} data-id="element-61" data-mp="2rz0m8ch4za1y" data-mpi={i}>
                <h3 data-id="element-62" data-mp="2s0buaohm73yv">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="group flex w-full items-center justify-between gap-6 py-6 text-left focus:outline-none focus-visible:ring-1 focus-visible:ring-gold-500" data-id="element-63" data-mp="2s0lj48qxb52z">
                    <span className={`font-display text-xl font-light transition-colors duration-200 group-hover:text-gold-400 sm:text-2xl ${isOpen ? 'neon-text-soft text-gold-400' : 'text-bone-50'}`} data-id="element-64" data-mp="1oj9jgzrwvo3k">
                      {faq.q}
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.3,
                  ease: [0.22, 1, 0.36, 1]
                }} className="shrink-0 text-gold-500 drop-shadow-[0_0_10px_rgba(34,227,127,0.6)]" aria-hidden="true" data-id="element-65" data-mp="1sm68p9byiigh">
                      <PlusIcon className="h-5 w-5" data-id="element-66" data-mp="1ybfzyuz7tanx" />
                    </motion.span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-67" data-mp="286rbl4fbu1rg">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.35,
                ease: [0.22, 1, 0.36, 1]
              }} className="overflow-hidden" data-id="element-68" data-mp="2c8mfmgon6t8x">
                      <p className="pb-7 pr-10 text-sm leading-relaxed text-bone-300 sm:text-base" data-id="element-69" data-mp="2vwlnnjrtnman">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}